import { render, staticRenderFns } from "./create.vue?vue&type=template&id=ef2c5f72&scoped=true"
import script from "./create.vue?vue&type=script&lang=js"
export * from "./create.vue?vue&type=script&lang=js"
import style0 from "./create.vue?vue&type=style&index=0&id=ef2c5f72&prod&lang=less&scoped=true"
import style1 from "./create.vue?vue&type=style&index=1&id=ef2c5f72&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2c5f72",
  null
  
)

export default component.exports